import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Intuos",
  "description": "",
  "published": "2006-11-20T00:00:00.000Z",
  "redirect_from": ["/blog/intuos/swizec/351"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://swizec.com/includes/editor_upload/Image/precious.jpg"
      }}><img parentName="a" {...{
          "src": "/includes/editor_upload/Image/precious_t.jpg",
          "alt": "Intuos3",
          "title": "Intuos3"
        }}></img></a><a parentName="p" {...{
        "href": "http://swizec.com/includes/editor_upload/Image/tablet_1.png"
      }}><img parentName="a" {...{
          "src": "/includes/editor_upload/Image/tablet_1_t.png",
          "alt": "First tablet",
          "title": "First tablet"
        }}></img></a></p>
    <p>{`Danes sem kupil novega Wacom Intuos3 iz preprostega razloga, da sem si ze dolgo zelel necesa podobnega in ker kupcek denarja ni bil dovolj velik za svoj prvotni namen, je preprosto lezal ta in pocel nic, bolje torej, da se ga zapravi za nekaj.`}</p>
    <p>{`Nisem se imel veliko casa poigrati se s stvarjo, samo eno majhno slicico, ampak reci, da po prvotnih tezavah privajanja, ki ga bo se nekaj, opazam, da je risanje veliko lazje kot z misko in samo cas bo lahko povedal koliko lazje in hitreje bo sedaj risati strip.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      